import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Define the Course type
interface Course {
  id: string;
  title: string;
  description: string;
  progress: number; // Progress percentage (0-100)
  status: 'purchased' | 'subscribed'; // Course type
}

// Define the state type
interface LearningCoursesState {
  courses: Course[];
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
  filter: 'all' | 'purchased' | 'subscribed';
}

// Initial state
const initialState: LearningCoursesState = {
  courses: [],
  status: 'idle',
  error: null,
  filter: 'all',
};

// Async thunk to fetch courses
export const fetchLearningCourses = createAsyncThunk('courses/fetchLearningCourses', async (userId: string) => {
  // const response = await axios.get(`/api/users/${userId}/learning-courses`);
  // return response.data as Course[];
  return  [
  {
    id: '1',
    title: 'Course 1',
    description: 'This is a course description',
    progress: 50,
    status: 'purchased',
  },
  {
    id: '2',
    title: 'Course 2',
    description: 'This is a course description',
    progress: 25,
    status: 'subscribed',
  },
  {
    id: '3',
    title: 'Course 3',
    description: 'This is a course description',
    progress: 75,
    status: 'purchased',
  },
] as Course[];

});

// Redux slice
export const coursesSlice = createSlice({
  name: 'learningCourses',
  initialState,
  reducers: {
    setFilter: (state, action) => {
      state.filter = action.payload; // Update the filter
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLearningCourses.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchLearningCourses.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.courses = action.payload;
      })
      .addCase(fetchLearningCourses.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Failed to fetch courses';
      });
  },
});

// Export actions and reducer
export const { setFilter } = coursesSlice.actions;
export default coursesSlice.reducer;
